<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { ModelListSelect } from "vue-search-select";
import Loader from "@/components/widgets/preloader";
import { mapGetters, mapActions, mapState } from "vuex";
import Swal from "sweetalert2";
import moment from "moment";
import axios from "axios";

/**
 * Advanced table component
 */
export default {
  page: {
    title: "Previous Debtors",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    ModelListSelect,
    Loader,
  },
  data() {
    return {
      title: "Previous Debtors",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "Previous Debtors",
          active: true,
        },
      ],
      totalRows: 1,

      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100, 200, 1000],
      filter: null,
      todoFilter: null,
      filterOn: [],
      todofilterOn: [],
      sortDesc: false,
      modal_id: "",
      fields: [
        {
          key: "index",
          sortable: true,
          label: "S/N",
        },
        {
          key: "cust",
          sortable: true,
          label: "CUSTOMER",
        },
        {
          key: "tt_amt",
          sortable: true,
          label: "TOTAL",
        },
        {
          key: "amt_paid",
          sortable: true,
          label: "PAID",
        },
        {
          key: "discount_field",
          sortable: true,
          label: "DISCOUNT",
        },
        {
          key: "balance",
          sortable: true,
          label: "BALANCE",
        },
        {
          key: "date",
          sortable: true,
          label: "DATE",
        },
        {
          key: "actions",
          sortable: false,
          label: "ACTION",
        },
      ],
      clear: {
        id: "",
        date: moment(new Date()).format("YYYY-MM-DD"),
        paid: "",
        mode: "",
        totals: "",
      },

      data: {
        dateto: moment(new Date()).format("YYYY-MM-DD"),
        datefrom: "",
        customer: "",
        branch_id: 0,
      },
      edit: {
        id: "",
        customer: "",
        paid: "",
        total: "",
        date: moment(new Date()).format("YYYY-MM-DD"),
      },

      delete: {
        id: "",
        customer: "",
      },
      amountError: "",
      modeError: "",
      filteredReport: [],
      is_uploading: false,
      totalDebtors: 0,
    };
  },
  computed: {
    // MAP STATE
    ...mapState("notification", ["type", "message", "show"]),
    ...mapGetters("saledetails", ["SaveStatus", "ImportedDebtors"]),
    ...mapGetters("setting", ["PaymentOptions", "GeneralSettings"]),
    ...mapGetters("auth", [
      "MyUserPerm",
      "business",
      "branch",
      "Branches",
      "branchid",
    ]),
    ...mapGetters("customers", ["Customers"]),

    /**
     * Total no. of records
     */

    rows() {
      return this.filteredReport ? this.filteredReport.length : 1;
    },

    /**
     * Todo list of records
     */
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.filteredReport ? this.filteredReport.length : 1;
  },

  watch: {
    show(newValue) {
      if (newValue == true) {
        if (this.type == "success") {
          this.closeModal(this.modal_id);
          Swal.fire("Success!", this.message.msg, "success");
        } else {
          Swal.fire("Error!", this.message.msg, "error");
        }
      }
    },
    ImportedDebtors(newValue) {
      if (newValue) {
        this.SetData();
        this.totalDebtors = this.ImportedDebtors.reduce(
          (acc, item) => acc + item.totalAmt,
          0,
        );
      }
    },
  },
  methods: {
    ...mapActions({
      FetchDebtors: "saledetails/fetchImportedDebtors",
      ClearBalance: "saledetails/ClearImportedDebt",
      FetchModes: "setting/fetchPaymentOptions",
      FetchGeneralSettings: "setting/fetchGeneralSettings",
      FetchCustomers: "customers/fetchCustomers",
      FetchBranches: "auth/fetchBranches",
      EditDebt: "saledetails/EditDebt",
      DeleteDebt: "saledetails/DeleteDebt",
    }),
    /**
     * Search the table data with search input
     */
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    // COMMA SEPERATORS
    thousandSeperator(m) {
      if (m !== "" || m !== undefined || m !== 0 || m !== "0" || m !== null) {
        return m
          .toString()
          .replace(/\D/g, "")
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return m;
      }
    },
    setDefaultMode() {
      let defaultop = this.PaymentOptions
        ? this.PaymentOptions
        : [].filter((mode) => {
            return mode.default == 1;
          });
      this.clear.mode = defaultop[0] ? defaultop[0].id : 0;
    },
    resetModal() {
      this.clear.id = "";
      this.clear.paid = "";
      this.setDefaultMode();
      this.clear.total = "";
    },
    resetError() {
      this.amountError = "";
      this.modeError = "";
    },
    addCommas() {
      this.clear.paid = this.thousandSeperator(this.clear.paid);
    },
    editCommas() {
      this.edit.total = this.thousandSeperator(this.edit.total);
      this.edit.paid = this.thousandSeperator(this.edit.paid);
    },
    ShowClear(data) {
      this.clear.id = data.id;
      this.clear.paid = this.thousandSeperator(
        data.totalAmt - data.totalPaid - data.discount,
      );
      this.clear.total = data.totalAmt;
    },
    checkAmt() {
      if (
        this.clear.paid.replace(/,/g, "") > this.clear.total &&
        this.GeneralSettings.deposit_balances == 0
      ) {
        this.amountError = "Amount Paid is greater than balance";
        return;
      } else {
        this.amountError = "";
      }
    },

    editDebt(modalId) {
      this.modal_id = modalId;
      if (this.edit.paid == "") {
        this.amountError = "Amount paid is required";
        return;
      } else {
        this.amountError = "";
      }
      if (
        this.edit.paid.replace(/,/g, "") > this.edit.total &&
        this.GeneralSettings.deposit_balances == 0
      ) {
        this.amountError = "Amount paid is greater than total";
        return;
      } else {
        this.amountError = "";
      }
      if (this.edit.mode == "") {
        this.modeError = "Payment method is required";
        return;
      } else {
        this.modeError = "";
      }
      this.EditDebt(this.edit);
    },

    deleteDebt(modalId) {
      this.modal_id = modalId;
      this.DeleteDebt(this.delete);
    },
    clearAmt(modalId) {
      this.modal_id = modalId;
      if (this.clear.paid == "") {
        this.amountError = "Amount Paid is required";
        return;
      } else {
        this.amountError = "";
      }
      if (
        this.clear.paid.replace(/,/g, "") > this.clear.total &&
        this.GeneralSettings.deposit_balances == 0
      ) {
        this.amountError = "Amount Paid is greater than balance";
        return;
      } else {
        this.amountError = "";
      }
      if (this.clear.mode == "") {
        this.modeError = "Payment Method is required";
        return;
      } else {
        this.modeError = "";
      }
      this.ClearBalance(this.clear);
    },
    closeModal(modalId) {
      this.resetError();
      this.resetModal();
      this.$nextTick(() => {
        this.$bvModal.hide(modalId);
      });
    },
    SetData() {
      if (this.ImportedDebtors) {
        this.filteredReport = this.ImportedDebtors;
      }
    },
    filterReport() {
      let date2 = this.data.dateto;
      let date1 = this.data.datefrom;
      this.filteredReport = this.ImportedDebtors.filter((element) => {
        if (this.data.branch_id == 0) {
          if (
            this.data.customer != "" &&
            this.data.datefrom == "" &&
            this.data.dateto != ""
          ) {
            return (
              element.customer.id == this.data.customer && element.date <= date2
            );
          } else if (
            this.data.customer == "" &&
            this.data.datefrom != "" &&
            this.data.dateto != ""
          ) {
            return element.date >= date1 && element.date <= date2;
          } else if (
            this.data.customer != "" &&
            this.data.datefrom != "" &&
            this.data.dateto != ""
          ) {
            return (
              element.customer_id == this.data.customer &&
              element.date >= date1 &&
              element.date <= date2
            );
          }
        } else {
          if (
            this.data.customer != "" &&
            this.data.datefrom == "" &&
            this.data.dateto != ""
          ) {
            return (
              element.customer.id == this.data.customer &&
              element.date <= date2 &&
              element.branch.id == this.data.branch_id
            );
          } else if (
            this.data.customer == "" &&
            this.data.datefrom != "" &&
            this.data.dateto != ""
          ) {
            return (
              element.date >= date1 &&
              element.date <= date2 &&
              element.branch.id == this.data.branch_id
            );
          } else if (
            this.data.customer != "" &&
            this.data.datefrom != "" &&
            this.data.dateto != ""
          ) {
            return (
              element.customer.id == this.data.customer &&
              element.date >= date1 &&
              element.date <= date2 &&
              element.branch.id == this.data.branch_id
            );
          } else {
            return element.branch.id == this.data.branch_id;
          }
        }
      });
    },
    // Import Debtors
    importFile(modelId) {
      this.is_uploading = true;
      let formData = new FormData();
      formData.append("file", this.file);

      const headers = { "Content-Type": "multipart/form-data" };
      axios
        .post("import_debtors", formData, { headers })
        .then((res) => {
          this.is_uploading = false;
          this.closeModal(modelId);
          if (res.status == 200) {
            let message = { msg: "Success upload" };
            this.FetchDebtors();
            this.$store.dispatch("notification/success", message);
          } else {
            let message = { msg: "Something went wrong and upload failed" };
            this.$store.dispatch("notification/error", message);
          }
        })
        .catch(() => {
          this.is_uploading = false;
          this.closeModal(modelId);
          let message = { msg: "Something went wrong and upload failed" };
          this.$store.dispatch("notification/error", message);
        });
    },
    handleUpload() {
      this.file = this.$refs.file.files[0];
    },

    resetEdit() {
      this.edit.id = "";
      this.edit.paid = "";
      this.edit.total = "";
      this.edit.customer = "";
    },
    resetDelete() {
      this.delete.id = "";
      this.delete.customer = "";
    },

    ShowEdit(data) {
      this.edit.id = data.id;
      this.edit.customer = data.customer.name + "-" + data.customer.contact;
      this.edit.paid = this.thousandSeperator(data.totalPaid);
      this.edit.total = this.thousandSeperator(data.totalAmt);
      this.edit.date = data.date;
    },
    ShowDelete(data) {
      this.delete.id = data.id;
      this.delete.customer = data.customer.name + "-" + data.customer.contact;
    },
  },
  created() {
    this.FetchBranches();
    this.FetchDebtors();
    this.FetchGeneralSettings();
    this.FetchCustomers();
    this.FetchModes();
    this.SetData();
    setTimeout(() => {
      this.setDefaultMode();
    }, 3000);
  },
};
</script>

<template>
  <Layout>
    <div class="row py-3 text-center">
      <h4 v-if="GeneralSettings.show_businessname == 1" class="text-primary">
        {{ business }}
      </h4>
      <h4 v-if="GeneralSettings.show_branchname == 1 && branch">
        <em
          v-if="
            GeneralSettings.show_branchname == 1 &&
            GeneralSettings.show_businessname == 1
          "
          >-</em
        >
        {{ branch }}
      </h4>
    </div>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-md-9">
                <h4 class="card-title">Previous Debtors</h4>
              </div>
            </div>

            <div class="row">
              <div class="mb-3 col-md-6" v-if="branchid == 0">
                <label>FILTER BY BRANCHES</label>

                <model-list-select
                  :list="Branches ? Branches : []"
                  v-model="data.branch_id"
                  option-value="id"
                  option-text="name"
                  placeholder="Select Branch"
                  @input="filterReport()"
                >
                </model-list-select>
              </div>
              <div v-else class="col-md-6"></div>
              <div class="col-md-3 mb-3">
                <b-button size="sm" variant="primary" @click="$router.go(-1)"
                  ><i class="fa fa-undo"></i> Back</b-button
                >
              </div>
              <div class="col-md-3 mb-3">
                <b-button
                  v-if="BranchData.BranchId != 0"
                  v-b-modal.import-debtors-modal
                  variant="info"
                  align="right"
                  ><i class="fa fa-plus"></i>Import Customers</b-button
                >
              </div>
            </div>

            <div class="row">
              <div class="col-4">
                <div class="form-group">
                  <label>From</label>
                  <input
                    @change="filterReport()"
                    type="date"
                    v-model="data.datefrom"
                    class="form-control"
                    v-limit-future-date
                  />
                </div>
              </div>
              <div class="col-4">
                <div class="form-group">
                  <label>To</label>
                  <input
                    @change="filterReport()"
                    type="date"
                    v-model="data.dateto"
                    class="form-control"
                    v-limit-future-date
                  />
                </div>
              </div>
              <div class="col-md-4 form-group">
                <label>CUSTOMERS</label>

                <model-list-select
                  :list="Customers ? Customers : []"
                  v-model="data.customer"
                  option-value="id"
                  option-text="name"
                  placeholder="Select Customer"
                  @input="filterReport()"
                >
                </model-list-select>
              </div>
            </div>

            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                      class="form-select form-select-sm"
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div
                  id="tickets-table_filter"
                  class="dataTables_filter text-md-end"
                >
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                      v-model="filter"
                      type="search"
                      placeholder="Search..."
                      class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                class="datatables"
                :items="filteredReport ? filteredReport : []"
                :fields="fields"
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :sort-desc.sync="sortDesc"
                :filter="filter"
                :filter-included-fields="filterOn"
                @filtered="onFiltered"
              >
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>
                <template #cell(tt_amt)="data">
                  {{ thousandSeperator(data.item.totalAmt) }}
                </template>
                <template #cell(cust)="data">
                  {{ data.item.customer.name }}-{{ data.item.customer.contact }}
                </template>
                <template #cell(amt_paid)="data">
                  {{ thousandSeperator(data.item.totalPaid) }}
                </template>
                <template #cell(discount_field)="data">
                  {{ thousandSeperator(data.item.discount) }}
                </template>
                <template #cell(balance)="data">
                  {{
                    thousandSeperator(
                      data.item.totalAmt -
                        (data.item.totalPaid + data.item.discount),
                    )
                  }}
                </template>
                <template
                  v-if="MyUserPerm.clear_debtors == 1"
                  #cell(actions)="data"
                >
                  <button
                    @click="ShowClear(data.item)"
                    class="btn btn-primary btn-sm"
                    v-b-modal.clear-modal
                  >
                    <i class="fa fa-check"></i> Clear
                  </button>
                  <button
                    @click="ShowEdit(data.item)"
                    class="btn btn-info btn-sm"
                    v-b-modal.edit-modal
                  >
                    <i class="fa fa-pencil-alt"></i> Edit
                  </button>
                  <button
                    @click="ShowDelete(data.item)"
                    class="btn btn-danger btn-sm"
                    v-b-modal.delete-modal
                  >
                    <i class="fa fa-trash"></i> Delete
                  </button>
                </template>
                <template #cell(details)="data">
                  <table class="table">
                    <tbody>
                      <tr
                        v-for="(det, d) in data.item.items"
                        :key="d"
                        width="100%"
                      >
                        <td>{{ det.product }}</td>
                        <td>{{ det.qty }}{{ det.usymbol }}</td>
                      </tr>
                    </tbody>
                  </table>
                </template>
              </b-table>

              <table class="table">
                <thead>
                  <tr>
                    <!-- <th style="width: 70px">No.</th> -->
                    <th>TOTAL</th>
                    <th>{{ thousandSeperator(totalDebtors) }}</th>
                  </tr>
                </thead>
              </table>
            </div>
            <Loader v-if="!filteredReport" />
            <div class="row">
              <div class="col">
                <div
                  class="dataTables_paginate paging_simple_numbers float-end"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- modal mark as expired starts -->
    <b-modal id="clear-modal" hide-footer @hidden="resetModal()">
      <template #modal-title>
        <h4 class="text-warning">
          Clear Credit of {{ thousandSeperator(clear.paid) }}
        </h4></template
      >
      <label>Amount Paid <span class="text-danger">*</span></label>
      <div class="input-group">
        <input
          type="text"
          class="form-control"
          v-model="clear.paid"
          placeholder="Quantity removed"
          @input="resetError(), addCommas(), checkAmt()"
        />
      </div>
      <div class="text-danger" v-if="amountError">
        <em>{{ amountError }}</em>
      </div>
      <div class="form-group">
        <label>Payment Method <span class="text-danger">*</span></label>
        <model-list-select
          :list="PaymentOptions ? PaymentOptions : []"
          v-model="clear.mode"
          option-value="id"
          option-text="mode"
          placeholder="Select Method"
          @input="resetError()"
        >
        </model-list-select>
      </div>
      <div class="text-danger" v-if="modeError">
        <em>{{ modeError }}</em>
      </div>
      <label>Payment Date</label>
      <div class="input-group">
        <input type="date" class="form-control" v-model="clear.date" />
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-secondary"
          data-dismiss="modal"
          @click="closeModal('clear-modal')"
          v-limit-future-date
        >
          <i class="fa fa-times"></i> Close
        </button>
        <button
          v-if="SaveStatus"
          type="button"
          class="btn btn-warning"
          disabled
        >
          <i class="fa fa-minus"></i> Confirm
          <b-spinner variant="light" small label="Submiting"></b-spinner>
        </button>
        <button
          v-else
          type="button"
          class="btn btn-warning"
          @click="clearAmt('clear-modal')"
        >
          <i class="fa fa-minus"></i> Confirm
        </button>
      </div>
    </b-modal>

    <!-- Edit modal starts -->
    <b-modal id="edit-modal" hide-footer @hidden="resetEdit">
      <template #modal-title>
        <h4 class="text-warning">
          Edit Debt of {{ thousandSeperator(edit.total) }} for
          {{ edit.customer }}
        </h4>
      </template>
      <label>Total Amount<span class="text-danger">*</span></label>
      <div class="input-group">
        <input
          type="text"
          class="form-control"
          v-model="edit.total"
          placeholder="Enter total amount"
          @input="resetError(), editCommas()"
        />
      </div>
      <label>Amount Paid <span class="text-danger">*</span></label>
      <div class="input-group">
        <input
          type="text"
          class="form-control"
          v-model="edit.paid"
          placeholder="Enter amount paid"
          @input="resetError(), editCommas(), checkAmt()"
        />
      </div>
      <div class="text-danger" v-if="amountError">
        <em>{{ amountError }}</em>
      </div>
      <label>Date</label>
      <div class="input-group">
        <input type="date" class="form-control" v-model="edit.date" v-limit-future-date />
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-secondary"
          data-dismiss="modal"
          @click="closeModal('edit-modal')"
        >
          <i class="fa fa-times"></i> Close
        </button>
        <button
          v-if="SaveStatus"
          type="button"
          class="btn btn-warning"
          disabled
        >
          <i class="fa fa-minus"></i> Confirm
          <b-spinner variant="light" small label="Submiting"></b-spinner>
        </button>
        <button
          v-else
          type="button"
          class="btn btn-warning"
          @click="editDebt('edit-modal')"
        >
          <i class="fa fa-minus"></i> Confirm
        </button>
      </div>
    </b-modal>
    <!-- Edit modal end -->

    <!-- Delete Modal -->
    <b-modal
      header-bg-variant="danger"
      header-text-variant="light"
      body-text-variant="danger"
      footer-bg-variant="danger"
      footer-text-variant="danger"
      id="delete-modal"
      hide-footer
      @hidden="resetDelete"
    >
      <template #modal-title> Delete This Imported Debt</template>
      <div class="form-group mb-2">
        <div class="input-group">
          <h5>
            Do you want to delete this Debt? Click Proceed Button to delete.
          </h5>
        </div>
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-secondary"
          data-dismiss="modal"
          @click="closeModal('delete-modal')"
        >
          <i class="fa fa-times"></i> Close
        </button>
        <button v-if="SaveStatus" type="button" class="btn btn-danger">
          <i class="fa fa-trash"></i> Proceed
          <b-spinner variant="light" small label="Deleting"></b-spinner>
        </button>
        <button
          v-else
          type="button"
          class="btn btn-danger"
          @click="deleteDebt('delete-modal')"
        >
          <i class="fa fa-trash"></i> Proceed
        </button>
      </div>
    </b-modal>
    <!-- Delete modal ends -->

    <!--DEBTORS EXCEL UPLOAD MODAL-->
    <b-modal
      id="import-debtors-modal"
      ref="modal"
      hide-footer
      title="Upload an excel file of Customers"
    >
      <div class="mb-2">
        <label class="col-form-label" for="upload-file"
          >Select file to upload:</label
        >
        <input
          id="upload-file"
          class="form-control"
          type="file"
          ref="file"
          @change="handleUpload"
        />
      </div>
      <div class="modal-footer">
        <button
          class="btn btn-secondary"
          @click="closeModal('import-debtors-modal')"
          type="button"
        >
          Close
        </button>
        <button
          v-if="is_uploading"
          type="button"
          class="btn btn-warning"
          disabled
        >
          Import Customers
          <b-spinner variant="light" small label="Submiting"></b-spinner>
        </button>
        <button
          v-else
          type="button"
          class="btn btn-primary"
          @click="importFile('import-debtors-modal')"
        >
          Import Customers
        </button>
      </div>
    </b-modal>
    <!-- DEBTORS EXCEL UPLOAD END -->
  </Layout>
</template>

<style>
.btn-primary,
.page-link {
  background-color: #fab031 !important;
  border-color: #fab031 !important;
}
</style>
